import { useContext, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import {
  ACTION_LOADER,
  ACTION_CUSTOMER__QUOTE__ID,
  ACTION_GUESTKEY,
  ACTION_GUESTQUOTE__DETAILS,
  ACTION_WISHLISTADDED__DATA,
  ACTION_WISHLIST_COUNT,
  ACTION_HEADERFOOTER__LOADING,
  ACTION_FETCH__HEADERFOOTER,
  ACTION_HOMEPAGE__LOADING,
  ACTION_FETCH__HOMEPAGE_FEATURE_PRODUCT,
  ACTION_CUSTOMER__DETAILS,
  ACTION_CUSTOMER__TOKEN,
  ACTION_ISLOGGEDUSER
} from "Store/action";
import axios from "axios";
import { SessionExpiredLogout, addWishList, getCartItems, mergeCart } from "Utilities";
import { APIQueryPost, APIQueryGet } from "APIMethods/API";
import { useLocation, useNavigate } from 'react-router-dom';
import RenderContext from 'Context/RenderContext';

const InitialFunctions = (baseURL, storeId, defaultURL) => {
  const dispatch = useDispatch();
    const updateCartItems = useSelector((state) => state?.updateCartItems);
    const guestKey = useSelector((state) => state?.guestKey);
    const navigate = useNavigate();
  const location = useLocation();
  const isLoggedUser = useSelector((state) => state?.isLoggedUser);
  const customerDetails = useSelector((state) => state?.customerDetails);
  const token = useSelector((state) => state?.token);
  const cartCount = useSelector((state) => state?.cartItems?.[0]?.totals_detail?.items?.length);
  const guestQuoteId = useSelector((state) => state?.guestQuoteDetails?.id);
  const checkHeaderFooterData = useSelector(state => state?.getHeaderFooterData?.checkHeaderFooterData);
  const customerQuoteId = useSelector((state) => state?.customerQuoteId);
  const countriesList = useSelector(state => state?.countriesList);
  const wishlistAddedData = useSelector((state) => state?.wishlistAddedData);
  const wilistProductId = useSelector((state) => state?.wilistProductId);
  const isSessionExpired = useSelector((state) => state?.isSessionExpired);
  const updateWishList = useSelector((state) => state?.updateWishList);
  const { loadPreRender, loadIfUser } = useContext(RenderContext)
  const searchParams = new URLSearchParams(location.search);
  const customerIdSearch = searchParams.get('customerId');

  const APIReferenceWishlist = useRef(false);
  const APIReferenceCartItems = useRef(false);
  const APIReferenceHeader = useRef(false);
  const APIReferenceCountry = useRef(false);
  const APIReferenceQuoteStatus = useRef(false);
  const getCustomerQuoteIds = (token, data) => {
    const quoteIdOptions = {
        isLoader: true,
        loaderAction: (bool) => {
        },
        setGetResponseData: (resData) => {
            if (resData?.status === 200) {
                if (!cartCount || cartCount === undefined) {
                    dispatch(ACTION_GUESTKEY(""));
                    dispatch(ACTION_GUESTQUOTE__DETAILS({}));
                }
                dispatch(ACTION_CUSTOMER__DETAILS(data));
                dispatch(ACTION_CUSTOMER__QUOTE__ID(resData?.data));
                dispatch(ACTION_CUSTOMER__TOKEN(token));
                dispatch(ACTION_ISLOGGEDUSER(true));
                if (cartCount) {
                    mergeCart(dispatch, updateCartItems, token, data?.id, guestKey, baseURL, storeId,guestQuoteId, defaultURL,  () => { },navigate, isSessionExpired);
                }
            }
        },
        getStatus: (res) => {
            if (res?.status !== 200) {
            }
        },
        axiosData: {
            url: `${defaultURL}/carts/mine`,
            method: "post",
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }
    }
    APIQueryPost(quoteIdOptions);
}
  const getUserDetails = (token) => {
    const userDetailsOptions = {
        isLoader: true,
        loaderAction: (bool) => {
        },
        setGetResponseData: (resData) => {
            if (resData?.status === 200) {
              getCustomerQuoteIds(token, resData?.data);
            }
        },
        getStatus: (res) => {
            if (res?.status !== 200) {
            }
        },
        axiosData: {
            url: `${defaultURL}/customers/me`,
            method: "get",
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }
    }
    APIQueryGet(userDetailsOptions);
}
  const getToken = async () => {
    try {
      const payload = {
        customerId: customerIdSearch,
      };
      const responseData = await axios.post(defaultURL + "/customer/getToken", payload);
      if (responseData?.status === 200) {
        getUserDetails(responseData?.data[0]?.token);
    }

    } catch (err) {
      console.log(err, "Validate Quote id err");
    }
  };
  // validate quote
  const getQuoteStatus = async (id) => {
    try {
      const payload = {
        data: {
          cartId: id,
          storeId: storeId,
        },
      };
      const responseData = await axios.post(defaultURL + "/cart/verify", payload);
      if (responseData?.data[0]?.code === 400) {
        if (isLoggedUser) {
          dispatch(ACTION_CUSTOMER__QUOTE__ID(""));
          getCustomerQuoteId();
        }
        else {
          dispatch(ACTION_GUESTKEY(""));
          dispatch(ACTION_GUESTQUOTE__DETAILS({}));
        }
      }

    } catch (err) {
      console.log(err, "Validate Quote id err");
    }
  };
  const getCustomerQuoteId = () => {
    const quoteIdOptions = {
      isLoader: true,
      loaderAction: (bool) => {
        dispatch(ACTION_LOADER(bool))
      },
      setGetResponseData: (resData) => {
        if (resData?.status === 200) {
          dispatch(ACTION_CUSTOMER__QUOTE__ID(resData?.data));
        }
      },
      getStatus: (res) => {
        if (res?.status !== 200) {
        }
      },
      axiosData: {
        url: `${defaultURL}/carts/mine`,
        method: "post",
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }
    }
    APIQueryPost(quoteIdOptions);
  }

  const setListItems = (data) => {
    let x = data && Object.keys(data);
    let allDetails = [];
    const list = new Promise((resolve, reject) => {
      x?.forEach((value, index, array) => {
        allDetails.push({
          sku: value,
          itemId: data[value]
        })
        if (index === array.length - 1) resolve();
      });
    });
    list.then(() => {
      dispatch(ACTION_WISHLISTADDED__DATA(allDetails));
      dispatch(ACTION_WISHLIST_COUNT(allDetails?.length));
    });
  }
  const wishListOptions = {
    setGetResponseData: (resData) => {

      if (resData?.data?.length) {
        setListItems(resData?.data?.[0]);
      } else {
        dispatch(ACTION_WISHLISTADDED__DATA([]));
        dispatch(ACTION_WISHLIST_COUNT(0));
      }
    },
    axiosData: {
      url: `${baseURL}/wishlist/userListSku`,
      headers: { Authorization: `Bearer ${token}` },
      paramsData: {
        customerId: customerDetails?.id ? customerDetails?.id : null,
        storeId: storeId
      }
    },
    getStatus: (res) => {
      SessionExpiredLogout(dispatch, res?.status, navigate, isSessionExpired);
    }
  };

  // headerFooterParams
  const headerFooterOptions = {
    isLoader: true,
    loaderAction: (bool) => dispatch(ACTION_HEADERFOOTER__LOADING(bool)),
    setGetResponseData: (resData) => {
      dispatch(ACTION_FETCH__HEADERFOOTER({
        checkHeaderFooterData: true,
        data: resData?.data?.[0]
      }))
    },
    axiosData: {
      url: `${defaultURL}/home/headerfooter`,

    }
  }
  
  const featureProduct = {
    isLoader: false,
    loaderAction: (bool) => {
      dispatch(ACTION_HOMEPAGE__LOADING(bool))
    },
    setGetResponseData: (resData) => {
      dispatch(ACTION_FETCH__HOMEPAGE_FEATURE_PRODUCT(
        resData?.data
      ))
    },
    axiosData: {
      url: `${defaultURL}/getFeaturedProducts`,

    }
  }
 
  useEffect(() => {
   
    if ((loadIfUser || loadPreRender) && location?.pathname === "/") {
      // Feature product
    APIQueryGet(featureProduct);

    }
  }, [loadIfUser, loadPreRender, location?.pathname]);
  
 

  // footer API call
  useEffect(() => {
    if (!checkHeaderFooterData && !APIReferenceHeader.current) {
      APIReferenceHeader.current = true;
      APIQueryGet(headerFooterOptions);
      setTimeout(() => APIReferenceHeader.current = false, 300);
    }
  }, [location?.pathname, checkHeaderFooterData]);



  // country list
  useEffect(() => {
    if (!APIReferenceCountry.current && location?.pathname !== "/" && !countriesList?.length) {
      APIReferenceCountry.current = true
      setTimeout(() => APIReferenceCountry.current = false, 300);
    }
  }, [location]);
  // add wishlist
  useEffect(() => {
    if (customerDetails?.id && wilistProductId?.id !== "" && token) {
      addWishList(
        defaultURL,
        dispatch,
        token,
        customerDetails?.id,
        { id: wilistProductId?.id, sku: wilistProductId?.sku },
        wishlistAddedData,
        storeId,
        navigate,
        isSessionExpired
      );
    }
  }, [customerDetails?.id, token]);
  // validate quote
  useEffect(() => {

    if (!APIReferenceQuoteStatus.current) {
      APIReferenceQuoteStatus.current = true;
      if (isLoggedUser && customerQuoteId) {
        getQuoteStatus(customerQuoteId);
      }
      if (!isLoggedUser && guestQuoteId) {
        getQuoteStatus(guestQuoteId);
      }
      setTimeout(() => (APIReferenceQuoteStatus.current = false), 300);
    }
  }, []);

  useEffect(() => {
    if (customerDetails?.id && !APIReferenceCartItems.current && customerQuoteId) {
      APIReferenceCartItems.current = true;
      if (isLoggedUser && customerQuoteId) {
        getCartItems(dispatch, () => { }, customerQuoteId, customerDetails?.id, () => { }, defaultURL, storeId, token);
      }
      setTimeout(() => (APIReferenceCartItems.current = false), 300);
    }
  }, [customerDetails?.id, customerQuoteId]);

  useEffect(() => {
    if (guestQuoteId && !APIReferenceCartItems.current) {
      APIReferenceCartItems.current = true;
      if (!isLoggedUser) {
        getCartItems(dispatch, () => { }, guestQuoteId, "", () => { }, defaultURL, storeId, token);
      }
      setTimeout(() => (APIReferenceCartItems.current = false), 300);
    }
  }, []);
  // get SKU Wishlist
  useEffect(() => {
    if (customerDetails?.id && token && !APIReferenceWishlist.current && !wilistProductId?.id && location?.pathname !== "/mijn-account/mijn-favorieten") {
      APIReferenceWishlist.current = true;
      APIQueryPost(wishListOptions);
      setTimeout(() => (APIReferenceWishlist.current = false), 300);
    }
  }, [customerDetails?.id, token, wilistProductId?.id, updateWishList]);
}

export default InitialFunctions;